export default __webpack_public_path__ + "static/media/36390511-9c88-42f2-890f-1ae4b1e7dd70.a489cc04.eot";